import { Expose } from 'class-transformer';

export class TempExcursionPostReleaseConfigResponseDto {
    /**
     * Temperature excursion post-release configuration ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    id: string;

    /**
     * Client Information Record ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    clientInformationRecordId: string;

    /**
     * How events are logged
     * @example 'Electronic system with manual backup'
     */
    @Expose()
    howEventLogged?: string;

    /**
     * Intake organization ID
     * @example '123e4567-e89b-12d3-a456-426614174001'
     */
    @Expose()
    intakeOrganizationId?: string;

    /**
     * Client QA contact email
     * @example 'qa.contact@client.com'
     */
    @Expose()
    clientQaContactEmail?: string;

    /**
     * Client procedure reference
     * @example 'SOP-TEMP-EX-2024-v1.0'
     */
    @Expose()
    clientProcedureRef?: string;

    /**
     * Notes
     * @example 'Follow temperature monitoring guidelines'
     */
    @Expose()
    notes?: string;

    /**
     * Creation timestamp
     * @example '2024-01-15T10:30:00Z'
     */
    @Expose()
    createdAt: Date;

    /**
     * Last update timestamp
     * @example '2024-01-15T10:30:00Z'
     */
    @Expose()
    updatedAt: Date;
}
